<template>
  <div>
    <p><a class="text-blue-400 hover:text-blue-600" @click.prevent="openHelp = !openHelp" href="#">{{openHelp ? 'OK, cool' : 'What is this?'}}</a></p>

      <div v-if="openHelp" class="mb-6">
        <p class="text-left w-full p-4 text-sm bg-gray-200">
          <a class="text-blue hover:text-blue-700" target="_blank" href="https://twitter.com/thatericsmith">@thatericsmith</a> and 
          <a class="text-blue hover:text-blue-700" target="_blank" href="https://twitter.com/jbsmith2004">@jbsmith2004</a> made <strong class="whitespace-no-wrap">Best Spots</strong> for you.<br><br>
          Come here and paste a city and a list of places that you recommend, or that friends have recommended.<br>We'll google each spot and give you a link so you can remember them.<br><br>
          Here's an example you can paste in and try:
        </p>
<pre class="bg-yellow-300 mb-2 p-1" v-if="!listPage">
Dallas // Fun food & drink spots
</pre>
<pre class="bg-yellow-300 mb-2 p-1" v-if="listPage">
Lucia // Crazy good Italian
Small Brewpub
Trompo Tacos // Yummy simple place
Honor Bar
Houndstooth // Delicious coffee
</pre>
      </div>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        openHelp: false,
      }
    },
    props: {
      listPage: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// HelpBox.vue?1ddf6cf4